import { compose } from 'react-apollo';
import ListFilters from './ListFilters';
import withAvailableFilters from './withAvailableFilters';

export default compose(withAvailableFilters)(ListFilters);
